export default ({
  pageState: { editorBlocks, editorIsBlockMoveView },
  data: { blockId, isSelected }
}) => {
  const updatedBlocks = {
    ...editorBlocks,
    [blockId]: {
      ...editorBlocks[blockId],
      isSelected
    }
  };

  let hasSelectedBlock = false;
  for (let id of Object.keys(updatedBlocks)) {
    if (hasSelectedBlock) break;
    if (updatedBlocks[id].isSelected) hasSelectedBlock = true;
  }

  return {
    editorBlocks: { ...updatedBlocks },
    editorIsBlockMoveView: hasSelectedBlock ? editorIsBlockMoveView : false
  };
};
